"use client";

import * as React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheSpecifiersProblem() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section id="the-specifiers-problem" className="bg-background py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        <div ref={ref} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-8 tracking-tight">
            Why Do Specifying Engineers Specify Evermark?
          </h2>
          
          <div className="space-y-6 text-lg md:text-xl text-muted-foreground leading-relaxed">
            <p>
              A specifying engineer writing an identification section carries the risk of what gets installed. A generic, open spec invites a low-bid substitution that fades, peels, or fails an inspection — and the callback lands on the spec. Writing a tight, defensible identification spec takes correct standards references and basis-of-design language that most suppliers don't provide.
            </p>
            
            <p>
              Evermark Industrial Solutions closes that gap. Evermark supplies CSI 3-part specification language, material data sheets, and standards references built around UL 508A, NFPA 70E, NEC 110.16, ANSI Z535, and MIL-SPEC — so an engineer can specify nameplates and labels by name, with the documentation to back the choice in a submittal review.
            </p>
            
            <p>
              The aim is to make specifying Evermark Industrial Solutions easier and more defensible than writing an open spec — correct material for the environment, the right standards cited, and a basis of design that holds up. The engineer remains responsible for the specification; Evermark supplies the marking and the supporting documentation.
            </p>
          </div>
        </div>
      </div>
    </section>;
}